<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Youth Festival</h1>
    <p class="lead mb-0 text-orange-light">Official Youth Festival Achievements</p>
  </div>
</div>

<div class="container px-lg-5 py-5 text-center">
  <div class="row g-5 align-items-center justify-content-center">
    <div class="col-12 col-lg-8 text-start">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-4">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-masks-theater me-2"></i> Cultural & Arts Honors
        </h3>

        <div class="image-wrapper shadow-lg border rounded-4 overflow-hidden mb-4">
          <img src="assets/img/quick-links/youth-festival-img.jpg" alt="Youth Festival Official Roster"
            class="img-fluid w-100">
        </div>

        <div class="mt-4">
          <a href="assets/img/quick-links/youth-festival-img.jpg" target="_blank"
            class="btn btn-warning fw-bold text-dark px-4 py-2"><i class="fa-solid fa-up-right-from-square me-2"></i>
            Open Image In New Tab</a>
        </div>
      </div>
    </div>
  </div>
</div>